import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Link, browserHistory } from 'react-router'
import { i18n } from 'react-i18n'
import AppStore from '../stores/AppStore'
import TemplateData from '../utility/getTemplateData'
import PostTransaction from '../confirmation/postTransaction'
import * as FPT from '../utility/fpt'

let PropTypes = React.PropTypes

const STYLES = {
	confirmationSignUpStatus: {
		marginTop: '20px'
	},
	confirmationSignUpP1: {
		margin: '0px auto 10px',
		fontWeight: 'normal',
		fontSize: '24px'
	},
	confirmationSignUpP2: {
		margin: '10px auto 0px',
		fontSize: '15px' ,
		maxWidth: '345px'
	}
}

const GuestSignUp = React.createClass({

	render () {
		return (
			<div>
				{this.props.signUpStatus ?
					<div className="donate_wrapper" style={{ ...STYLES.confirmationSignUpStatus }}>
						<div className="row confirmation_sign_up_success">
							<div className="col-xs-12 col-sm-12 col-md-12">
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP1 }}>
									{this.props.successMessage1}
								</p>
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP2 }}>
									{this.props.successMessage2}
								</p>
							</div>
						</div>
					</div>
				:
					<div className="donate_wrapper" style={{ ...STYLES.confirmationSignUpStatus }}>
						<div className="row confirmation_sign_up_success">
							<div className="col-xs-12 col-sm-12 col-md-12">
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP1 }}>
									{this.props.failMessage1}
								</p>
								<p className="text-center" style={{ ...STYLES.confirmationSignUpP2 }}>
									{this.props.failMessage2}
								</p>
							</div>
						</div>
					</div>
				}
			</div>
		);
	}
});


export default React.createClass({

	mixins: [i18n('confirmation/confirmation')],

	propTypes:{
		label: React.PropTypes.string
	},

	getInitialState () {

		let confirmationData = AppStore.getConfirmation() || {}

		return {
			amount: confirmationData.amount || '',
			postBackData: confirmationData || {},
			displayMyAccount: confirmationData.showAccountOverview || false,
			orgName : (TemplateData.donationName) ? TemplateData.donationName : '',

			autoRedirect : TemplateData.returnAutoRedirect !== '',
			autoRedirectUrl : (TemplateData.charityReturnUrl) ? TemplateData.charityReturnUrl : '',
			autoRedirectMethod: (TemplateData.returnMethod) ? TemplateData.returnMethod : '',
			syncIpnUrl: confirmationData.syncReturnUrl || '',

			isSignUp: confirmationData.isSignUp || false,
			signUpStatus: confirmationData.signUpSuccess || false
		};
	},

	componentDidMount () {

		this.serverRequest = $.post('/donate/guest/postTransaction', {}).then(function(response) {
			$('.spinneroverlay').hide();
			if(response.data.confirmationData){
				// AppActions.updateConfirmation({ confirmation: result.data.confirmationData });
				this.setState({
					amount: response.data.confirmationData.amount || AppStore.getDonationAmount(),
					guestSignUp: response.data.confirmationData.guestSignUp || false ,
					displayMyAccount: response.data.confirmationData.showAccountOverview || false
				})
			}

		}.bind(this))

		let confData = AppStore.getConfirmation() || {}
		let isSignUp = confData.showAccountOverview || false;
		let trid = confData.confirmationNumber || '';

		if (TemplateData.fptPageName === 'guestULSignUp' || isSignUp) {
			FPT.trackPage('main:donate:wps:signup:success', 'main:donate:wps:signup:success:web::', 'trid', trid)
		} else {
			FPT.trackPage('main:donate:wps:guest:success', 'main:donate:wps:guest:success:web::', 'trid', trid)
		}
	},

	componentWillUnmount() {
		this.serverRequest.abort()
	},

	handleMyAccount() {
		console.log('MY ACCOUNT LINK IS CLICKED');
		FPT.trackLinkClick('myAccount');
		window.location.href = '/myaccount'
	},

	handleAuthRedirectFail() {

		let finalUrl = this.state.autoRedirectUrl

		if (this.state.syncIpnUrl) {
			finalUrl = this.state.syncIpnUrl
		}

		window.location.href = finalUrl
	},

	render () {

		let yourdonation = this.i18n('label.yourdonation')
		let returnText = this.i18n('label.returnText')
		let returnto = this.i18n('label.returnto')
		let myAccount = this.i18n('label.myAccount')

		yourdonation = yourdonation.split('<br>')[0]
		yourdonation = yourdonation.replace('{amount}', this.state.amount)
		returnText = returnText.replace('{orgName}', this.state.orgName)

		returnto = returnto.replace('{orgName}', this.state.orgName)

		const guestSignUpProps = {

			signUpStatus: this.state.signUpStatus,
			successMessage1: 'Your PayPal account is ready to go!',
			successMessage2: 'We’ll send you an email with more details about how to use your account.',
			failMessage1: 'We couldn’t create your PayPal account',
			failMessage2: 'We’ll send you an email to help get your PayPal account going. '
		}

		return (
			<div>
				<div className="donate_wrapper">
					<div className="row confirmation">
						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_img_holder center-block">
								<span className="icon icon-large icon-positive-large" aria-hidden="true"></span>
							</div>
						</div>

						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_header">
								<h4 className="text-center">{yourdonation}</h4>
								<h4 className="text-center">{this.state.orgName}</h4>
							</div>
						</div>

						{this.state.autoRedirect ?
							<div>
								<div className="col-xs-12 col-sm-12 col-md-12">
									<div className="confirmation_reciept_wrapper">
										<h6 className="text-center">{returnText}</h6>
									</div>
									<div className="text-center">
										<a onClick={this.handleAuthRedirectFail} className="btn btn-primary pp_guest_btn">{returnto}</a>
									</div>
								</div>
								<PostTransaction
									orgName={this.state.orgName}
									postdata={this.state.postBackData}
									method={this.state.autoRedirectMethod}
									action={this.state.autoRedirectUrl}/>
							</div> : null}
						{this.state.guestSignUp ? <div></div> : null}
						{(this.state.displayMyAccount && !this.state.autoRedirect) ?
							<div className="col-xs-12 col-sm-12 col-md-12 text-center">
								<div className="pp_guest_btn_wrapper">
									<a onClick={this.handleMyAccount} className="btn btn-primary pp_guest_btn">{myAccount}</a>
								</div>
							</div>: null}
					</div>
				</div>

				{ this.state.isSignUp ? <GuestSignUp { ...guestSignUpProps } /> : null }

			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./guest/confirmation.js
 **/